(() => {
  const root = document.documentElement;
  const isOctober = () => {
    try {
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit' }).formatToParts(new Date());
      const part = type => parts.find(value => value.type === type)?.value;
      return part('year') === '2026' && part('month') === '10';
    } catch (error) {
      return false;
    }
  };
  let active = isOctober();
  root.classList.toggle('gf-haunted', active);
  const clone = selector => document.querySelector(selector)?.content.cloneNode(true);
  const signalTargets = [
    '.gh-hero h1 > span', '.gh-eyebrow', '.gh-strip__status',
    '.gf-city h2', '.gf-kids h2', '.gf-end h2', '.gf-portals strong',
    '.gf-play h2', '.gf-video h2', '.gh-home-invite h2',
    '.gh-intro h2', '.gh-intro__eyebrow', '.gh-division h3',
    '.gh-division__label', '.ckq__hero h1', '.ckq__card-name',
    '.ckq__card-top', '.ckq__manifesto-lead', '.ckq__manifesto-hit',
    '.ckq__eyebrow', '.ckq__result-label',
    '.ckq__dossier-label', '#city-kids-divisions > header h1'
  ].join(',');
  const readText = node => {
    if (node.nodeType === Node.TEXT_NODE) return node.nodeValue;
    if (node.nodeName === 'BR') return '\n';
    if (node.classList?.contains('gh-echo')) return '';
    return Array.from(node.childNodes).map(readText).join('');
  };
  const corruptText = (text, heavy) => {
    const above = ['\u030d', '\u030e', '\u0311', '\u031a'];
    const below = ['\u0324', '\u0329', '\u0330'];
    return Array.from(text).map((letter, index) => {
      if (!/\p{L}/u.test(letter)) return letter;
      const seed = letter.codePointAt(0) + index;
      const top = index % (heavy ? 2 : 3) === 0 ? above[seed % above.length] : '';
      const bottom = index % (heavy ? 4 : 7) === 0 ? below[seed % below.length] : '';
      return letter + top + bottom;
    }).join('');
  };
  const decorate = () => {
    if (!active) return;
    document.querySelectorAll(signalTargets).forEach(element => {
      if (element.closest('form,.ckq__question,.gh-readable,.gh-echo,[data-gh-normal-hero]')) return;
      if (element.querySelector('a,button,input,textarea,select,img,svg')) return;
      const plain = readText(element).trim();
      if (plain.length < 3) return;
      let readable = element.querySelector(':scope > .gh-readable');
      let echo = element.querySelector(':scope > .gh-echo');
      if (!readable || !echo) {
        readable = document.createElement('span');
        readable.className = 'gh-readable';
        readable.append(...element.childNodes);
        echo = document.createElement('span');
        echo.className = 'gh-echo';
        echo.setAttribute('aria-hidden', 'true');
        element.append(readable, echo);
        element.classList.add('gh-corrupt');
        const seed = Array.from(plain).reduce((total, letter) => total + letter.codePointAt(0), 0);
        element.style.setProperty('--gh-phase', '-' + ((seed % 11) * .63).toFixed(2) + 's');
      }
      const signal = corruptText(plain, element.matches('.gh-hero h1 > span,.ckq__card-name'));
      if (echo.dataset.ghEcho !== signal) echo.dataset.ghEcho = signal;
    });
  };
  let pendingFrame = 0;
  const scheduleDecoration = () => {
    if (!active || pendingFrame) return;
    pendingFrame = window.requestAnimationFrame(() => {
      pendingFrame = 0;
      decorate();
    });
  };
  const restore = () => {
    document.querySelectorAll('.gh-corrupt').forEach(element => {
      const readable = element.querySelector(':scope>.gh-readable');
      if (readable) element.replaceChildren(...readable.childNodes);
      element.classList.remove('gh-corrupt');
      element.style.removeProperty('--gh-phase');
    });
    document.querySelectorAll('[data-gh-added],[data-gh-intro],[data-gh-card-added]').forEach(node => node.remove());
  };
  const addDivision = (container, key, before, interactive) => {
    if (!container || container.querySelector('[data-gh-added]')) return;
    const fragment = clone('template[data-gh-division="' + key + '"]');
    if (!fragment) return;
    const section = fragment.querySelector('.gh-division');
    section.dataset.ghAdded = 'true';
    if (interactive) {
      const toggle = clone('#gh-share-toggle');
      if (toggle) section.querySelector('.gh-division__note').before(toggle);
    }
    container.insertBefore(fragment, before || null);
  };
  const refresh = scope => {
    if (!active) return;
    const result = scope?.matches?.('.ckq__result') ? scope : document.querySelector('.ckq__result');
    if (result?.dataset.ghDivision) {
      const dossier = result.querySelector('.ckq__dossier');
      addDivision(dossier?.parentElement, result.dataset.ghDivision, dossier, true);
      const card = result.querySelector('.ckq__result-card');
      if (card && !card.querySelector('[data-gh-card-added]')) {
        const mark = clone('#gh-card-mark-template');
        if (mark) card.append(mark);
      }
    }
    const guide = document.querySelector('#city-kids-divisions');
    if (guide) {
      if (!guide.querySelector('[data-gh-intro]')) {
        const intro = clone('#gh-intro-template');
        if (intro) guide.prepend(intro);
      }
      ['hustler', 'arson', 'maverick', 'anchor', 'cypher', 'diva'].forEach(key => {
        const card = guide.querySelector('#' + key);
        if (card) card.dataset.ghDivision = key === 'arson' ? 'arsonist' : key;
        const participation = card?.querySelector('#' + key + '-participation');
        addDivision(card, key === 'arson' ? 'arsonist' : key, participation, false);
      });
    }
    decorate();
  };
  const update = () => {
    const next = isOctober();
    active = next;
    root.classList.toggle('gf-haunted', active);
    if (active) refresh();
    else restore();
  };
  window.GriffeyHalloween = {
    refresh,
    update,
    shareLine(result) {
      if (!active || !result.querySelector('[data-gh-share]:checked')) return '';
      const section = result.querySelector('[data-gh-added]');
      const costume = section?.querySelector('[data-gh-costume]')?.textContent.trim();
      const sin = section?.querySelector('[data-gh-sin]')?.textContent.trim();
      const label = document.querySelector('#gh-share-toggle')?.dataset.shareLabel;
      return costume && sin ? '\n' + label + ' ' + costume + ' / ' + sin + '\n#TheCityPossessed' : '';
    }
  };
  const init = () => {
    refresh();
    const main = document.querySelector('#MainContent');
    if (main) new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target instanceof Element ? record.target : record.target.parentElement;
        return !target?.closest('.gh-readable,.gh-echo') && (record.type === 'characterData' || record.addedNodes.length);
      })) scheduleDecoration();
    }).observe(main, { childList: true, subtree: true, characterData: true });
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
    window.addEventListener('pageshow', update);
    window.setInterval(update, 60000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
